module.exports = __webpack_public_path__ + "img/burkinafaso.7e6493d1.svg";